// El proyecto se cambió en otra pestaña (u otro dispositivo) — ADR-2026-11-03-dos-pestanas-no-se-pisan.
//
// Antes ganaba la última pestaña que guardaba: una pestaña vieja pisaba el proyecto
// entero al primer cambio, sin aviso. Ahora el guardado se frena y la persona elige:
// abrir lo último (recargar) o quedarse con lo de esta pestaña (guardar igual).
import { AlertTriangle } from 'lucide-react';
import { useAperturaAnimada } from '../../hooks/useAperturaAnimada';

export function AvisoDeConflicto({
  hayConflicto,
  onAbrirLoUltimo,
  onQuedarmeConEsto,
}: {
  hayConflicto: boolean;
  onAbrirLoUltimo: () => void;
  onQuedarmeConEsto: () => void;
}) {
  const { montado, visible } = useAperturaAnimada(hayConflicto, 150);
  if (!montado) return null;
  return (
    <div
      role="alert"
      className={`pointer-events-auto flex max-w-[min(560px,calc(100vw-32px))] flex-wrap items-center gap-x-3 gap-y-2 rounded-lg bg-white py-2.5 pl-3 pr-2 text-[12.5px] text-brand-black shadow-md ring-1 ring-black/[0.06] transition-[opacity,transform,filter] ease-out ${
        visible
          ? 'opacity-100 duration-300 motion-safe:translate-y-0 motion-safe:blur-0'
          : hayConflicto
            ? 'opacity-0 duration-300 motion-safe:translate-y-3 motion-safe:blur-[4px]'
            : 'opacity-0 duration-150 motion-safe:-translate-y-3 motion-safe:blur-[4px]'
      }`}
    >
      <div className="flex min-w-0 flex-1 items-start gap-2.5">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-warning" aria-hidden="true" />
        <div className="min-w-0">
          <p className="font-semibold">Este proyecto se cambió en otra pestaña</p>
          <p className="mt-0.5 text-brand-black/70">
            Para no pisar esos cambios, esta pestaña dejó de guardar.
          </p>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <button
          type="button"
          onClick={onAbrirLoUltimo}
          className="rounded-md bg-brand-primary px-3 py-1.5 text-[12px] font-semibold text-white transition-[background-color,transform] duration-150 ease-out hover:bg-brand-primary-hover active:scale-[0.96]"
        >
          Abrir lo último
        </button>
        <button
          type="button"
          onClick={onQuedarmeConEsto}
          className="rounded-md px-3 py-1.5 text-[12px] font-semibold text-brand-black/70 transition-[background-color,transform] duration-150 ease-out hover:bg-black/[0.04] active:scale-[0.96]"
        >
          Quedarme con esto
        </button>
      </div>
    </div>
  );
}
